
const base = {
    timer: null
}

export default {
    base
}
